import { LANGS } from "types/shared";
import { ILanguageSettingsContext, ILanguageSettingsState } from "./LanguageSettingsProviderTypes";

export enum KEYWORD_TYPES {
  MOBILE = "MOBILE",
  ADMIN = "ADMIN",
  TYPES = "TYPES"
}

export const INITIAL_LANGUAGE_SETTINGS_CONTEXT: ILanguageSettingsContext = {
  currentKeywordType: KEYWORD_TYPES.MOBILE,
  keywords: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  // adminKeywords: {
  //   data: [],
  //   itemCount: 0,
  //   skip: 0,
  //   take: 10
  // },
  contentTypes: [],
  currentLanguage: LANGS.KA,
  searchValue: "",
  keywordsQuery: {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "id"
  },
  initialInputValues: {
    mobile: null,
    admin: null,
    types: null
  },
  initialContentTypeInputValues: null,
  inputValues: {
    mobile: null,
    admin: null,
    types: null
  },
  contentTypeInputValues: null,
  handleKeywordTabChange: () => {},
  handleLanguageTabChange: () => {},
  handleSearchChange: () => {},
  handleKeywordInputChange: () => {},
  handleContentTypeInputChange: () => {},
  handleKeywordsPaginationClick: () => {},
  handleSubmit: () => {}
}

export const INITIAL_LANGUAGE_SETTINGS_STATE: ILanguageSettingsState = {
  currentKeywordType: KEYWORD_TYPES.MOBILE,
  keywords: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10
  },
  // adminKeywords: {
  //   data: [],
  //   itemCount: 0,
  //   skip: 0,
  //   take: 10
  // },
  currentLanguage: LANGS.KA,
  contentTypes: [],
  searchValue: "",
  initialInputValues: {
    mobile: null,
    admin: null,
    types: null
  },
  initialContentTypeInputValues: null,
  inputValues: {
    mobile: null,
    admin: null,
    types: null
  },
  contentTypeInputValues: null,

}